module.exports = __webpack_public_path__ + "media/images/curve3-6ae3b125e786473dc5b73ab42d4c6735.png";